<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="search_tab">
      <div class="search_Text w1200">和 "{{ keyword }}" 相关的内容</div>
      <div class="search_tab_c w1200">
        <router-link :to="{ path: '/search', query: { keyword: keyword } }"
          ><span :class="{ side: num == 0 }">全部</span>
        </router-link>
        <router-link
          :to="{ path: '/search_course', query: { keyword: keyword } }"
          ><span :class="{ side: num == 1 }">课程</span>
        </router-link>
        <router-link
          :to="{ path: '/search_TestPaper', query: { keyword: keyword } }"
          ><span :class="{ side: num == 2 }">练习-套卷</span>
        </router-link>
        <router-link
          :to="{ path: '/search_Section', query: { keyword: keyword } }"
          ><span :class="{ side: num == 3 }">练习-单项</span>
        </router-link>
        <!-- <router-link :to="{path:'/search_languageTest',query:{keyword:keyword}}"><span
            :class="{'side': num == 4}">全真模考</span></router-link> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="search_null" v-if="KPTestsTestPaperNum == 0">
        <img src="../../assets/courselist/search.png" alt="" class="wuImg" />
        <p>没有你要找的内容，可以换个关键词试试</p>
      </div>
      <div class="search_main KPTestsTestPaper_main" v-else>
        <!-- <div class="search_con">课程找到{{courseArrNum}}条结果
        </div> -->
        <ul class="clearfix">
          <li v-for="(item, index) in KPTestsTestPaper">
            {{ item.Title }}
            <strong v-if="item.Unfinished">
              <span
                class="btn_status btn_status_1"
                @click="todetail(item, 'a_jump', 3)"
                >继续答题</span
              >
              <span
                class="btn_status btn_status_2"
                @click="todetail(item, 'a_jump', 1)"
                >重新答题</span
              >
            </strong>

            <span class="btn_status" v-else @click="todetail(item, 'a_jump', 2)"
              >去答题</span
            >
          </li>
        </ul>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="12"
            :total="total"
            background
            layout="total,prev, pager, next, jumper,->"
          >
          </el-pagination>
        </div>
        <!-- block end -->
      </div>
    </div>
  </div>
</template>

<script>
import { getRandom } from "@/common/utils";
import { setEncryption } from "@/api/common";
import Header from "../../components/header/Header.vue"; //公共头部
export default {
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header
  },
  metaInfo() {
    return {
      title: "启德考培在线 - 启德考培旗下在线课堂_出国考试在线培训_考培网校",
      meta: [
        {
          name: "keywords",
          content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      num: 2,
      listBox: [], //列表盒子
      limit: 12,
      currentPage: 1,
      keyword: "",
      KPTestsTestPaper: [],
      KPTestsTestPaperNum: 0,
      total: 0, //总条数
      tokenkey: ""
    };
  },
  created() {
    //自动触发写入的函数
    let that = this;
    that.keyword = that.$route.query.keyword;
    this.tokenkey = this.$cookies.get("token");
    // 课程
    that.getKPTestsTestPaper(that.currentPage, that.limit, that.keyword);
  },
  methods: {
    iconShrink() {
      this.screenup = true;
    },
    iconOpen() {
      this.screenup = false;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      let that = this;
      // console.log(`当前页: ${val}`);
      that.currentPage = val;
      that.getKPTestsTestPaper(that.currentPage, that.limit, that.keyword);
    },

    getKPTestsTestPaper(currentPage, limit, keyword) {
      let that = this;
      this.$api.get(
        "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper?page=" +
          currentPage +
          "&limit=" +
          limit +
          "&keyword=" +
          keyword,
        "",
        res => {
          console.log(res, "练习-套卷");
          if (res.data.code == 200) {
            that.KPTestsTestPaperNum = res.data.count;
            that.KPTestsTestPaper = res.data.results;
            that.total = res.data.count;
          }
        }
      );
    },
    judgeIsAnswer() {
      let flag = false;
      if (this.$store.state.userInfo.Type == 2) {
        flag = true;
      } else if (
        this.$store.state.userInfo.VipList &&
        this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      ) {
        flag = true;
      }
      return flag;
    },
    async todetail(itemData, type, restart) {
      if (this.tokenkey) {
        if (!itemData.IsPublic && !this.judgeIsAnswer()) {
          this.$refs.CDKModal.open();
          return;
        }
        // TODO
        //改域名
        this.$utils.gatAllNavUrl({
          ...itemData,
          paperId: itemData.TestPaperId,
          restart,
          a_flag: restart == 99 ? 2 : 1,
          transcript:itemData.Transcript,
        });
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
    }
  }
};
</script>

<style scoped>
.search_tab {
  padding: 30px;
}

.search_tab .search_Text {
  height: 20px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
  text-align: left;
  margin-bottom: 50px;
  position: relative;
}

.search_tab .search_Text a {
  width: 123px;
  height: 25px;
  position: absolute;
  top: 13px;
  right: 0;
  background: url(../../assets/index/more.png) no-repeat;
  background-size: cover;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 16px;
  text-align: center;
}

.search_tab_c span {
  display: inline-block;
  font-weight: 400;
  font-size: 26px;
  color: #333333;
  line-height: 26px;
  margin-right: 50px;
  cursor: pointer;
  font-weight: 400;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.search_tab_c span:hover {
  font-weight: 500;
  color: #ff0659;
}

.search_tab_c span.side {
  font-weight: 500;
  color: #ff0659;
}

.main {
  padding-top: 20px;
  padding-bottom: 78px;
}

.search_con {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  margin-bottom: 30px;
}

.search_main {
  margin-bottom: 50px;
}

.KPTestsTestPaper_main ul {
  border-top: 1px #d8d8d8 solid;
  margin-bottom: 30px;
}

.KPTestsTestPaper_main ul li {
  width: 1140px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 16px;
  border-bottom: 1px #d8d8d8 solid;
  padding: 0 30px;
  cursor: pointer;
}

.KPTestsTestPaper_main ul li strong {
  font-weight: normal;
}

.KPTestsTestPaper_main ul li strong span {
  margin-left: 20px;
}

.block {
  width: 1180px;
  margin: 0 auto;
  text-align: right;
}

.search_null {
  width: 1180px;
  margin: 0 auto;
  text-align: center;
}

.search_null p {
  font-size: 12px;
  color: #333;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/page2/search/search_TestPaper.vue